/* global window */
/* global document */
import { Fragment, useContext } from 'react'
import { withRouter } from 'react-router'
import { Header, BreadCrumb } from 'components'
import { Layout } from 'antd'
import { config } from 'utils'
import store from 'store2'
import styles from './PrimaryLayout.module.scss';
import { RouterContext, setSidebar } from 'components-contexts/RouterContext'
import { MenuList } from 'client/components/doctors/sidebar/SideMenuList'

const { Content } = Layout


const PatientLayout = (props) => {
  const { children, isAuthenticated, isMobile } = props;
  const { state, dispatch } = useContext(RouterContext)

  const { collapsed, theme } = state;


  const onCollapseChange = collapsed => {
    dispatch(setSidebar(collapsed));
  }


  const user = store.get('user') || {}
  const menus = MenuList

  const headerProps = {
    theme,
    menus,
    collapsed,
    notifications: null,
    onCollapseChange,
    avatar: user.avatar,
    username: user.username,
    fixed: config.fixedHeader,
    publicLayout: true,
    isMobile,
    onAllNotificationsRead() {
      // dispatch({ type: 'app/allNotificationsRead' })
    },
  }


  return (
    <Fragment>
      <Layout hasSider={true}>

        <div
          className={styles.container}
          style={{ paddingTop: config.fixedHeader ? 52 : 0 }}
          id="primaryLayout"
        >
          <Header {...headerProps} />
          <Content className={styles.content}>
            {isAuthenticated && <BreadCrumb />}
            {children}
          </Content>
        </div>
      </Layout>
    </Fragment>
  )

}

export default withRouter(PatientLayout)

